/**
 * L_TASK_EFILING_DATA.FORM_DATA(템플릿 변수) + 문서 formData → ChangeFyeForm / ChangeFyeEFiling 용 taskData
 */
export function mapNewFinancialPeriodToB41Code(m: string | number | undefined): string {
  const s = String(m ?? '').trim().toLowerCase();
  if (s.includes('52')) return 'B41002';
  return 'B41001';
}

function trimStr(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

/**
 * @param entityCd — 태스크 ENTITY_CD (ChangeFye formFields.entity)
 * @param flat — toTemplateVariables() 형태 또는 문서 치환 필드 (snake_case)
 * @param storedNested — 이미 저장된 nested formData (formFields 등) 있으면 병합
 */
export function buildChangeFyeTaskDataFromPresetSources(
  entityCd: string,
  flat: Record<string, any> | null | undefined,
  storedNested: Record<string, any> | null | undefined,
): { formData: Record<string, any> } {
  const f = flat && typeof flat === 'object' ? flat : {};
  const nested =
    storedNested && typeof storedNested === 'object' && Object.keys(storedNested).length > 0
      ? storedNested
      : null;

  const newFye =
    trimStr((nested as any)?.formFields?.revisedFinancialYearEndDate) ||
    trimStr(f.new_fye_date ?? f.newFyeDate);
  const periodFromNested = trimStr((nested as any)?.formFields?.financialYearPeriod);
  const periodFromFlat = mapNewFinancialPeriodToB41Code(
    f.new_financial_period_months ?? f.newFinancialPeriodMonths,
  );
  const financialYearPeriod = periodFromNested || periodFromFlat;

  const reg =
    trimStr(f.company_registration_no ?? f.companyRegistrationNo) ||
    trimStr((nested as any)?.RegistrationNo?.value);
  const name =
    trimStr(f.company_name ?? f.companyName) || trimStr((nested as any)?.CompanyName?.value);

  const formFields = {
    entity: trimStr((nested as any)?.formFields?.entity) || trimStr(entityCd),
    revisedFinancialYearEndDate: newFye,
    financialYearPeriod,
  };

  return {
    formData: {
      ...(nested || {}),
      formFields,
      RegistrationNo: { value: reg },
      CompanyName: { value: name },
    },
  };
}
